// src/utils/eventsCompatibility.jsx - FIXED: No duplicate exports
import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { enhancedEventsData } from '../data/eventsData';


// Convert new data format to old format for existing HomePage
export function getCompatibleEvents() {
  return enhancedEventsData.map(event => ({
    ...event,
    icon: () => {
      if (event.iconType === 'emoji') {
        return React.createElement('span', { className: 'text-3xl' }, event.iconValue);
      } else if (event.iconType === 'heroicon' && event.iconName === 'ChatBubbleLeftRightIcon') {
        return React.createElement(ChatBubbleLeftRightIcon, { className: 'w-8 h-8' });
      }
      return React.createElement('span', { className: 'text-3xl' }, '📅');
    }
  }));
}

// Helper to render icons in new components
export function renderEventIcon(event, size = "w-16 h-16") {
  if (event.iconType === 'emoji') {
    return React.createElement('span', { className: 'text-4xl' }, event.iconValue);
  } else if (event.iconType === 'heroicon' && event.iconName === 'ChatBubbleLeftRightIcon') {
    return React.createElement(ChatBubbleLeftRightIcon, { className: size });
  }
  return React.createElement('span', { className: 'text-4xl' }, '📅');
}